import { websocket } from '@/src/shared/lib/websocket'

export function websocketSocketId() {
  return websocket.socketId('default')
}

export function websocketEmit<P>(event: string, payload: P) {
  websocket.emitDefault(event, payload)
}
